import ClientStorage from "../func/clientStorage";

const storage = new ClientStorage('user');

const useSaveReferralCode = () => {
  const getReferralCode = (): { referral_code: string; isLocalStrage: boolean } => {
    const url = window.location.href;
    const regex = /referral_code=([^&]*)/g;
    let match;
    let lastReferralCode = '';
    let isLocalStrage = false;
    while ((match = regex.exec(url)) !== null) {
      lastReferralCode = match[1];
    }

    if (lastReferralCode === '') {
      const code = storage.get('referral_code');
      lastReferralCode = code ? code : '';
      isLocalStrage = code ? true : false;
    }

    return {
      referral_code: lastReferralCode,
      isLocalStrage: isLocalStrage,
    };
  };

  const saveReferralCode = (code?: string) => {
    const { referral_code } = getReferralCode();
    //本地存储
    storage.update('referral_code', code || referral_code);
  };

  return {
    getReferralCode,
    saveReferralCode,
  };
};

export default useSaveReferralCode;
